module.exports = __webpack_public_path__ + "static/img/ufi_logo.7418f0a1.png";